var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 16,
    viewBox: "0 0 118 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7122 0V16H17.4352V5.59543L13.6915 15.9817H9.0207L5.27692 5.59543V15.9817H0V0H7.70147L11.3561 10.5143L15.0108 0H22.7122Z",
    fill: "#0597FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8476 13.5314H30.3066L29.326 16H23.8174L31.0196 0H37.1167L44.3368 16H38.828L37.8476 13.5314ZM36.3857 9.81943L34.0682 4.04114L31.7683 9.81943H36.3857Z",
    fill: "#0597FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8728 10.8069H50.7368V16H45.46V0H56.5485C60.845 0 63.216 2.02971 63.216 5.30286C63.216 7.71657 62.0216 9.27086 60.0249 10.0937L63.7153 15.9817H58.0283L54.8728 10.8069ZM50.7368 7.14971H55.7998C57.3508 7.14971 57.85 6.32686 57.85 5.30286C57.85 4.26057 57.2082 3.712 55.7998 3.712H50.7368V7.14971Z",
    fill: "#0597FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2006 7.99086C83.2006 14.7383 78.2625 15.9817 73.3777 15.9817H65.0522V0H73.3777C78.2625 0 83.2006 1.28 83.2006 7.99086ZM77.8702 7.99086C77.8702 3.87657 75.3566 3.69371 72.219 3.69371H70.347V12.3063H72.2012C75.3566 12.3063 77.8702 12.1234 77.8702 7.99086Z",
    fill: "#0597FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2962 0V16H85.0015V0H90.2962Z",
    fill: "#0597FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8192 0V16H92.5244V0H97.8192Z",
    fill: "#0597FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 0V16H112.402L105.325 6.49143V16H100.048V0H105.646L112.723 9.52686V0H118Z",
    fill: "#0597FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logoBlue.a8aca5f7d1d0ce4f168b415f7147f524.svg";
export { ForwardRef as ReactComponent };